module.exports = __webpack_public_path__ + "img/電気回路_1_5.23aa94d9.png";